import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LPLeadsLogin = () => {
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const VALID_KEY = "Tx@fP0^HYxV54Xde_@!w"; 

  const handleSubmit = (e) => {
    e.preventDefault();
    if (key === VALID_KEY) {
 
      sessionStorage.setItem("lpLeadsLoggedIn", "true");

      navigate("/campaign/lp-leads");
    } else {
      setError("Invalid key. Please try again.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f9f9f9",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          padding: "30px",
          border: "1px solid #ddd",
          borderRadius: "10px",
          background: "#fff",
          width: "320px",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>Enter Secret Key</h2>
        <input
          type="password"
          placeholder="Enter your key"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "10px",
            background: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Login
        </button>
        {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
      </form>
    </div>
  );
};

export default LPLeadsLogin;
